import React from 'react'
import { useEffect as UseEffect, useState as UseState, useRef as UseRef } from "react";
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@mui/material/styles';
import constants from '../../utils/constants';

const index = ({ className, mode, id, options, disabled, value, name, onChange, help, defaultValue, itemField, modeView, viewRedirectRole, design, onBlur, onFocus, mandatory }) => {

    const [initialOptions, setInitialOptions] = UseState([]);
    const [filteredOptions, setFilteredOptions] = UseState(initialOptions);
    const [loadingMoreOptions, setLoadingMoreOptions] = UseState(false);
    const [maxWidth, setMaxWidth] = UseState(0);
    const textMeasureRef = UseRef(null);

    const handleChange = (event, newValue) => {
        if (onChange) {
            onChange(event, newValue);
        }
    };

    const handleFocus = (event, newValue) => {
        if (onFocus) {
            onFocus(event, newValue);
        }
    };

    const onFormatNumber = (e) => {
        onBlur(e);
    }

    const handleInputChange = (event, newInputValue) => {

        const inputValue = newInputValue.trim().toLowerCase();

        const matchedOptions = options
            .filter(option => option.isInactive === "0" && option.label.toLowerCase().includes(inputValue));

        setFilteredOptions(matchedOptions);

        if (inputValue.length > 2 && matchedOptions.length > initialOptions.length) {
            if (!loadingMoreOptions) {
                setLoadingMoreOptions(true);
                setTimeout(() => {
                    const additionalOptions = options
                        .filter(option => option.isInactive === "0")
                        .slice(100, 200);
                    setInitialOptions(prevOptions => [...prevOptions, ...additionalOptions]);
                    setFilteredOptions([...matchedOptions, ...additionalOptions]);
                    setLoadingMoreOptions(false);
                }, 300);
            }
        }
        let tam = value ? value.length : 0;
        console.log('handleInputChange****')
        if (matchedOptions.length === 1 && inputValue.length > tam && modeView !== 'l') {//modificacion 0703
            console.log('ingresa 1-> ' + JSON.stringify(matchedOptions[0]))
            handleChange(event, matchedOptions[0])
        }

        if (inputValue.length === 0) {
            console.log('ingresa 2')
            handleChange(event, null)
        }
    };

    const handleFieldClick = (event) => {
        if (modeView === 'r' && viewRedirectRole === true) {
            event.preventDefault();
            const baseUrl = window.location.origin;
            window.open(`${baseUrl}/${itemField.sourceSelect}?id=${value.id}&m=r`, '_blank');
        }
    };

    UseEffect(() => {
        if (filteredOptions.length > 0 && textMeasureRef.current) {
            const maxLabelWidth = filteredOptions.reduce((max, option) => {
                textMeasureRef.current.innerText = option.label;
                const labelWidth = textMeasureRef.current.offsetWidth;
                return Math.max(max, labelWidth);
            }, 0);
            setMaxWidth(maxLabelWidth + 25);
        } else {
            setMaxWidth(170);
        }
    }, [filteredOptions]);

    //const inputWidth = value ? (value.label !== undefined ? `${value.label.length}ch` : "0ch") : '0ch';
    const inputWidth = value
        ? ((value.label !== undefined && value.label !== null)
            ? `${value.label.replace(/\s/g, '').length}ch`
            : '0ch')
        : '0ch';

    const minWidth = name ? name.length + "ch" : "0ch";


    UseEffect(() => {
        const activeOptions = options.filter(option => option.isInactive === "0");
        if (value && value.id) {
            const selectedOption = options.find(option => option.id === value.id);

            if (selectedOption && activeOptions.some(option => option.id === value.id)) {
                //setFilteredOptions([selectedOption, ...activeOptions.slice(0, 100)]);
                setFilteredOptions(activeOptions.slice(0, 100));

            } else {

                setFilteredOptions(activeOptions.slice(0, 100));
            }
        } else {
            setFilteredOptions(activeOptions.slice(0, 100));
        }
    }, [options, value]);


    UseEffect(() => {

        if (value && value.id) {
            const selectedOption = options.find(option => option.id === value.id);
            if (!selectedOption) {
                //console.log('value-> '+JSON.stringify(value))
                //handleChange(null, null);
            }
        }
    }, [options, value]);

    return (
        <div onClick={handleFieldClick}>
            <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
                <Box>
                    <Tooltip title={help} placement="top">
                        <FormControl className={className ?? undefined} key={id} size="small">
                            <Autocomplete
                                sx={{
                                    fontSize: "0.65rem",
                                    "& .MuiInputBase-root": {
                                        paddingLeft: "0px !important"
                                    },
                                    "& .MuiAutocomplete-listbox": {
                                        fontSize: "inherit",
                                        fontWeight: "500",
                                        lineHeight: "inherit"
                                    }
                                }}
                                onFocus={(event, newValue) => handleFocus(event, newValue)}
                                id={id}
                                options={filteredOptions}
                                disabled={disabled}
                                value={value}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => {

                                    if (value !== null && value !== undefined) {
                                        return value?.id && option?.isInactive === "0" ? Number(option.id) === Number(value.id) : false;
                                    }

                                }}
                                onChange={(event, newValue) => handleChange(event, newValue)}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label={design !== 'table' ? <span>
                                        {name}
                                        {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
                                    </span> : null}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", marginTop: !value ? '-8px' : '' }
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        style: {
                                            height: '1px', width: inputWidth, minWidth: minWidth, fontSize: "inherit", fontWeight: '600', lineHeight: "inherit",
                                            cursor: modeView === 'r' ? "pointer" : "default", paddingRight: "0px", paddingLeft: "8px"
                                        }
                                    }}

                                />}
                                style={{ width: 'auto', fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}
                                defaultValue={defaultValue}
                                readOnly={mode}
                                onInputChange={handleInputChange}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}>
                                        {option.label}
                                    </MenuItem>
                                )}
                                popupIcon={modeView === 'r' ? null : undefined}
                                PaperComponent={(props) => (
                                    <Paper {...props} style={{ width: maxWidth + 20, fontSize: "0.65rem", fontWeight: '600' }} />
                                )}
                                onBlur={onFormatNumber}
                            />
                        </FormControl>
                    </Tooltip>
                </Box>
                <span ref={textMeasureRef} style={{ position: 'absolute', visibility: 'hidden', whiteSpace: 'nowrap', fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }} />
            </ThemeProvider>
        </div>
    )
}

export default index;